import { render, staticRenderFns } from "./BatchDivisionCard.vue?vue&type=template&id=3d2e8817"
import script from "./BatchDivisionCard.vue?vue&type=script&lang=js"
export * from "./BatchDivisionCard.vue?vue&type=script&lang=js"
import style0 from "./BatchDivisionCard.vue?vue&type=style&index=0&id=3d2e8817&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports